'use strict';
import React from 'react';
import flux from 'utils/flux';

var RedirectPage = React.createClass({
    displayName: 'RedirectPage',
    mixins: [],
    propTypes: {},
    statics: {
        willTransitionTo: function(transition) {
            if(flux.getStore('app').isSamlLogin()) {
                console.log("saml")

                if (flux.getStore('app').isAuthenticated()) {
                    transition.redirect('landing-page');
                }
                else {
                    console.log("proper transition");
                    window.location.reload();
                    transition.redirect('saml_error');
                }
            } else if (flux.getStore('app').isAuthenticated()) {
                console.log("logged in");

                if (!flux.getStore('app').hasAcceptedLatestTerms()) {
                    transition.redirect('/accept_terms', {}, { nextPath: transition.path });
                }
                transition.redirect('landing-page');
            } else if (flux.getStore('app').isNoneLogin()) {
                console.log("none");

                flux.getStore('app').loginUser({}).then(() => {
                    window.location.reload();
                    transition.redirect('landing-page', {}, { nextPath: transition.path });
                });
            } else {
                console.log("login")

                transition.redirect('/login', {}, {nextPath: transition.path});
            }
        }
    },
    render() {
        return (<div/>);
    }
});

module.exports = RedirectPage;



// WEBPACK FOOTER //
// ./app/pages/redirect/index.jsx